import { Form, FormGroup } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { NovaSenhaSchema } from "shared/yup/schemas/NovaSenhaSchema";
import TextInput from "shared/components/input/TextInput";
import { CustomLabel } from "shared/components/input/CustomLabel";
import { RequestNewPassword } from "types/request/RequestNewPassword";
import { UseMutateFunction } from "react-query";
import { AxiosResponse } from "axios";

interface NewPasswordProps {
  urlToken: string;
  username: string | undefined;
  requestFn: UseMutateFunction<
    AxiosResponse<RequestNewPassword, any>,
    any,
    RequestNewPassword,
    void
  >;
  resetPassword?: boolean;
}

interface NovaSenhaForm {
  senha: string;
  confirmarSenha: string;
}

const NewPassword: React.FC<NewPasswordProps> = (props) => {
  const { register, control, handleSubmit, setValue } = useForm<NovaSenhaForm>({
    resolver: yupResolver<NovaSenhaForm>(NovaSenhaSchema),
  });

  const renderHeaderFirstAccess = () => {
    return (
      <div className="d-flex flex-column text-center mt-5">
        <div className="fs-4 mb-2">
          Bem vindo(a), ao <b>Group</b> Condomínios!
        </div>
        <div style={{ fontSize: "2.5vh" }}>
          <div>
            Crie uma senha para acessar a melhor plataforma de gestão <br /> condominial em nuvem
          </div>
        </div>
      </div>
    );
  };

  const renderCampoEmail = () => {
    return (
      <FormGroup className="mb-2">
        <CustomLabel>E-mail</CustomLabel>
        <Form.Control size="sm" type="email" id="user-email" disabled value={props.username} />
      </FormGroup>
    );
  };

  const renderCampoSenha = () => {
    return (
      <TextInput
        className="mb-2"
        control={control}
        name="senha"
        id="senha"
        register={register}
        label="Senha"
        placeholder="Digite sua senha"
        usarValidacaoParaFormulario
        setValue={setValue}
        isPassword
      />
    );
  };

  const renderCampoConfirmarSenha = () => {
    return (
      <TextInput
        control={control}
        name="confirmarSenha"
        id="confirmarSenha"
        register={register}
        label="Confirme a nova senha"
        placeholder="Confirme sua senha"
        usarValidacaoParaFormulario
        onKeyDown={handleKeyDown}
        setValue={setValue}
        isPassword
      />
    );
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(criarNovaSenha)();
    }
  };

  const criarNovaSenha = (form: NovaSenhaForm) => {
    props.requestFn({
      email: props.username,
      password: form.senha,
      confirmPassword: form.confirmarSenha,
      activationKey: !props.resetPassword ? props.urlToken : undefined,
      resetKey: props.resetPassword ? props.urlToken : undefined,
    } as RequestNewPassword);
  };

  const renderBotaoSubmit = () => {
    return (
      <Form.Group>
        <div className="d-grid gap-2 mt-5">
          <button
            className={"botao-entrar"}
            onClick={(e) => {
              e.preventDefault();
              handleSubmit(criarNovaSenha)();
            }}
          >
            Salvar
          </button>
        </div>
      </Form.Group>
    );
  };

  return (
    <>
      {renderHeaderFirstAccess()}
      <Form className="pe-5 ps-5 mt-4">
        {renderCampoEmail()}
        {renderCampoSenha()}
        {renderCampoConfirmarSenha()}
        {renderBotaoSubmit()}
      </Form>
    </>
  );
};

export default NewPassword;
